import { render, staticRenderFns } from "./Artificial-intelligence.vue?vue&type=template&id=7a070567&scoped=true"
import script from "./Artificial-intelligence.vue?vue&type=script&lang=js"
export * from "./Artificial-intelligence.vue?vue&type=script&lang=js"
import style0 from "./Artificial-intelligence.vue?vue&type=style&index=0&id=7a070567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a070567",
  null
  
)

export default component.exports